<template>
  <div
    class="bg-image h-100 position-relative overflow-hidden"
    :style="{
      backgroundImage: `url(${backgroundSrc})`,
      backgroundColor: backgroundColor
    }"
    :class="`${backgroundClass}`"
  >
    <div class="container text-start overflow-auto">
      <div class="row py-5">
        <div
          class="mb-3 mb-lg-0"
          :class="{
            col: useInstructions,
            'col-12 col-md-6 offset-md-1': !useInstructions
          }"
        >
          <div class="card bg-dark text-light bg-opacity-90 mb-3">
            <div class="card-body p-4">
              <h1 class="card-title">{{ appTitle }}</h1>
              <!-- Main Content -->
              <div>
                <p class="card-subtitle h5 mb-3">
                  At the end of the activity, please download or screenshot the
                  certificate of completion, and upload into the provided canvas
                  folder for this week’s assignment.
                </p>
                <p>
                  This app is designed to give you a little practice applying
                  the environmental conditions we went over in lecture to
                  different situations you might encounter while rooting
                  cuttings. Through each situation, you will adjust mist levels,
                  light levels, and toggle on or off bottom heat. These are very
                  general approximations, rather than a precise application, but
                  it will help you learn when is appropriate to have bottom heat
                  on cuttings and how/when to slow the transpiration rate of
                  your cuttings. The app will give you feedback along the way to
                  help guide your choices until you have a fully rooted geranium
                  liner! Note, the app will not let you move off a stage until
                  you have selected and applied the correct environmental
                  condition for each stage, so if you’re stuck on one, just keep
                  on adjusting.
                </p>
              </div>
              <!-- Activity page link, default set to route Main -->
              <div>
                <button
                  class="btn btn-lg btn-primary w-100 fw-bold"
                  @click="startActivity(startIndex)"
                >
                  {{ callToActionText }} Activity
                </button>
                <div
                  v-if="savedLocation !== 0"
                  class="
                    alert alert-info
                    w-100
                    h-100
                    text-center text-dark
                    mb-0
                    mt-3
                    fw-bold
                    fs-6
                  "
                >
                  <p>
                    Resume from where you left off: Scenario
                    {{ savedLocation + 1 }}
                  </p>
                  <button
                    class="btn btn-lg btn-secondary w-100 fw-bold"
                    @click="startActivity(savedLocation)"
                  >
                    Resume
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="useControls" class="card bg-dark text-light bg-opacity-90">
            <div class="card-body p-4">
              <UserControls />
            </div>
          </div>
        </div>
        <div v-if="useInstructions" class="col">
          <div class="card bg-dark text-light bg-opacity-90">
            <div class="card-body p-4">
              <UserInstructions />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserInstructions from "@/components/ui/UserInstructions.vue";
import UserControls from "@/components/ui/UserControls.vue";
import config from "@/data/config.json";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LandingView",
  components: { UserInstructions, UserControls },
  data() {
    return {
      startIndex: 0, // sets the saved location back to 0

      appTitle: config.meta.title,
      // From within the @/assets folder
      // Be aware of file size: Max Size 512kb
      backgroundImg: config.landingView.backgroundImg,
      backgroundAlt: config.landingView.backgroundAlt,
      backgroundColor: config.landingView.backgroundColor,
      backgroundClass: config.landingView.backgroundClass,
      callToActionText: config.landingView.callToActionText,
      callToActionTextDestination:
        config.landingView.callToActionTextDestination,
      useInstructions: config.landingView.useInstructions,
      useControls: config.landingView.useControls
    };
  },
  computed: {
    ...mapGetters({ savedLocation: "getSavedLocation" }),
    backgroundSrc() {
      if (!this.useBackgroundImg) {
        return;
      }

      return require(`@/assets/${this.backgroundImg}`);
    },
    useBackgroundImg() {
      return this.backgroundImg !== "";
    }
  },
  methods: {
    ...mapActions(["setSavedLocation"]),
    startActivity(index) {
      this.setSavedLocation(index).then(() => {
        this.$router.push({ name: this.callToActionTextDestination });
      });
    }
  }
};
</script>
<style scoped>
.bg-image {
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
}
.bg-opacity-90 {
  --bs-bg-opacity: 0.9;
}
</style>
